import { useQueryClient } from "react-query";

import { StaffUser as StaffUserType } from "src/common/types";

export namespace AuthService {
  export namespace hooks {
    export const useStaffUser = () => {
      const queryClient = useQueryClient();
      return queryClient.getQueryData(`STAFF_USER`) as StaffUserType;
    };

    export const useStaffUserRole = () => {
      const staffUser = useStaffUser();
      return staffUser.role;
    };
  }
}
